import moment from 'moment';
import { RECENT_SEARCHES_KEY, RECENT_SEARCHES_MAX_LOCAL } from './constants';

export type LocalRecentSearch = {
   organizationId?: string;
   mapboxId: string;
   placeName: string;
   center: string;
   mapboxObject?: any;
   checkin: string;
   checkout: string;
   adults?: number;
   children?: number;
   rooms?: number;
   yearOlds?: number[];
   isPet?: boolean;
   countryCode?: string;
   lastSearchedAt: string;
};

const todayDateString = () => moment().startOf('day').format('YYYY-MM-DD');

const safeParse = (raw: string | null): LocalRecentSearch[] => {
   if (!raw) return [];
   try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
   } catch {
      return [];
   }
};

const dedupKey = (item: LocalRecentSearch) => item.mapboxId || item.placeName;

export const readLocalRecentSearches = (): LocalRecentSearch[] => {
   if (typeof window === 'undefined') return [];
   const raw = window.localStorage.getItem(RECENT_SEARCHES_KEY);
   const today = todayDateString();
   return safeParse(raw)
      .filter(item => !!item.checkin && item.checkin >= today)
      .sort((a, b) => (a.lastSearchedAt < b.lastSearchedAt ? 1 : -1));
};

export const writeLocalRecentSearches = (items: LocalRecentSearch[]): void => {
   if (typeof window === 'undefined') return;
   const trimmed = items.slice(0, RECENT_SEARCHES_MAX_LOCAL);
   window.localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(trimmed));
};

export const upsertLocalRecentSearch = (incoming: LocalRecentSearch): LocalRecentSearch[] => {
   const existing = safeParse(typeof window !== 'undefined' ? window.localStorage.getItem(RECENT_SEARCHES_KEY) : null);
   const key = dedupKey(incoming);
   const filtered = existing.filter(item => dedupKey(item) !== key);
   const next = [{ ...incoming, lastSearchedAt: incoming.lastSearchedAt || new Date().toISOString() }, ...filtered];
   writeLocalRecentSearches(next);
   return next;
};

export const removeLocalRecentSearchByMapboxId = (mapboxId: string): void => {
   const existing = safeParse(typeof window !== 'undefined' ? window.localStorage.getItem(RECENT_SEARCHES_KEY) : null);
   writeLocalRecentSearches(existing.filter(item => item.mapboxId !== mapboxId));
};

export const clearLocalRecentSearches = (): void => {
   if (typeof window === 'undefined') return;
   window.localStorage.removeItem(RECENT_SEARCHES_KEY);
};
